export default "__VITE_PUBLIC_ASSET__7e06beba__"